import React, { ReactElement, ReactNode } from 'react'

import { Badge, BadgeColor, getColorStyles } from '../Badge'
import { Space } from '../Space'
import { Text } from '../Text'
import * as Styled from './styles'

export interface BadgeWithLabelProps {
  color?: BadgeColor
  children?: ReactNode
  badge?: ReactNode
}

export const BadgeWithLabel = ({ color = 'accent', children, badge }: BadgeWithLabelProps): ReactElement => {
  return (
    <Styled.BadgeWithLabelWrapper>
      {/* Could be number value as badge is often used for presenting those */}
      {badge !== undefined && (
        <Badge color={color} mode="subtle">
          {badge}
        </Badge>
      )}
      {children && (
        <>
          {badge !== undefined && <Space horizontal size="s6" />}
          <Text variant="bodySM" color={getColorStyles(color, 'subtle', false).textColor} weight="medium">
            {children}
          </Text>
        </>
      )}
    </Styled.BadgeWithLabelWrapper>
  )
}
